var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-no-information",class:{
    'icon-top': _vm.iconPosition == 'top',
    'icon-top-responsive': _vm.iconPositionResponsive == 'top',
    'is-dark': _vm.isDark,
  }},[_c('div',{staticClass:"message"},[_c('p',{staticClass:"alert-title"},[_c('span',[_c('img',{attrs:{"src":_vm.error_icon,"alt":"Info"}})]),_vm._v(" No data available at the moment! ")]),_c('p',{staticClass:"subtitle-1"},[_vm._v(" Unable to load the information due to a system error, please try again later or contact your administrator. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }